import React from 'react';
import { CopyItem, InfoItem, InfoItemLabel, InfoItemsWrapper, InfoItemValue } from '@/common/components/validClaimForm/ValidClaimForm.styled';
import Icon from '@/common/components/Icon';
import { ButtonsWrapper, Title, Wrapper } from './refundDetails.styles';
import ActionButton from '@/common/components/buttons/ActionButton';
import { Colors } from '@/common/colors/colors';
import { getFields } from '../../helpers/getFields';

const RefundDetails = ({ hook }) => {
	const { handleCopyItem, selectedRefund } = hook;

    const fields = getFields(selectedRefund);

    return (
		<Wrapper>
			<Title>Refund Details</Title>
			<InfoItemsWrapper>
                {fields.map((field) => (
                    <InfoItem>
                        <InfoItemLabel>{field.label}</InfoItemLabel>
                        <InfoItemValue cursor='pointer' onClick={() => handleCopyItem(field.value)}>
                            <CopyItem >{field.value ?? 'N/A'}</CopyItem>
                            <Icon name='copy' />
                        </InfoItemValue>
                    </InfoItem>
                ))}
			</InfoItemsWrapper>
            <ButtonsWrapper>
                <ActionButton style={{ width: '100px' }} color={Colors.green} onClick={hook.handleAcceptRefund}>
                    Accept
                </ActionButton>
                <ActionButton style={{ width: '100px' }} color={Colors.red} onClick={() => hook.setConfirmationPopup(true)}>
                    Decline
                </ActionButton>
            </ButtonsWrapper>
		</Wrapper>
	);
};

export default RefundDetails;